import React, { useState } from 'react'
import BtnPrimary from '../element/Buttons/btnPrimary';
import ThreeDotLoader from '../element/ButtonLoader/ThreeDotLoader';
import Dialog from '../element/Dialog';

const ArchiveModal = ({ dialogOpen, onDialogClose, onConfirm, title = "Are you sure you want to archive this?", subtitle = "Archiving this checklist will impact all associated Providers who have submitted documents against it. Please confirm if you want to proceed with deleting the entire checklist." }) => {
    const [buttonDisabled, setButtonDisabled] = useState(false);

    const handleConfirm = () => {
        setButtonDisabled(true);

        if (onConfirm) {
            onConfirm();
        }

        setTimeout(() => {
            setButtonDisabled(false);
            onDialogClose();
        }, 2000);
    };

    return (
        <Dialog
            isOpen={dialogOpen}
            onClose={onDialogClose}
            width={400}
            onRequestClose={onDialogClose}
            bodyOpenClassName="overflow-hidden"
        >
            <div className="flex flex-col items-center justify-center pt-6 px-6 pb-6">
                {/* Archive Icon */}
                <svg width="57" height="57" viewBox="0 0 57 57" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="4.5" y="4.97656" width="48" height="48" rx="24" fill="#FFD7A1" />
                    <rect x="4.5" y="4.97656" width="48" height="48" rx="24" stroke="#FFF4E5" stroke-width="8" />
                    <path d="M37 23.9766V29.9766C37 33.7478 37 35.6335 35.8284 36.805C34.6569 37.9766 32.7712 37.9766 29 37.9766H28M20 23.9766V29.9766C20 33.7478 20 35.6335 21.1716 36.805C21.8763 37.5098 22.8395 37.7906 24.3161 37.9025" stroke="#FF8E1C" stroke-width="1.5" stroke-linecap="round" />
                    <path d="M28.5 19.9766H20.5C19.5572 19.9766 19.0858 19.9766 18.7929 20.2695C18.5 20.5624 18.5 21.0338 18.5 21.9766C18.5 22.9194 18.5 23.3908 18.7929 23.6837C19.0858 23.9766 19.5572 23.9766 20.5 23.9766H36.5C37.4428 23.9766 37.9142 23.9766 38.2071 23.6837C38.5 23.3908 38.5 22.9194 38.5 21.9766C38.5 21.0338 38.5 20.5624 38.2071 20.2695C37.9142 19.9766 37.4428 19.9766 36.5 19.9766H32.5" stroke="#FF8E1C" stroke-width="1.5" stroke-linecap="round" />
                    <path d="M28.5 23.9766V32.9766M28.5 32.9766L31.5 29.6433M28.5 32.9766L25.5 29.6433" stroke="#FF8E1C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>


                {/* Close Button */}
                <button
                    onClick={onDialogClose}
                    className="absolute top-4 right-4 text-gray-400 hover:text-gray-600"
                >
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </button>

                {/* Title */}
                <h3 className="text-base font-semibold text-gray-900 mb-2 text-center">
                    {title}
                </h3>

                {/* Subtitle */}
                <p className="text-sm text-gray-500 text-center mb-6">
                    {subtitle}
                </p>

                {/* Buttons */}
                <div className="flex gap-3 w-full">
                    <button
                        className="flex-1 h-10 rounded-lg border border-gray-300 bg-white text-gray-700 text-sm font-semibold hover:bg-gray-50 focus:bg-white duration-100"
                        onClick={onDialogClose}
                                            style={{ backgroundColor: "#FFF4E5", borderColor: "#FFF4E5" }}

                    >
                        Cancel
                    </button>

                    <button
                        disabled={buttonDisabled}
                        onClick={handleConfirm}
                        className="flex-1 h-10 rounded-lg border  bg-white text-white text-sm font-semibold "
                        style={{ backgroundColor: '#FF8E1C', borderColor: '#FF8E1C' }}
                    >
                        {buttonDisabled ? <ThreeDotLoader /> : "Confirm"}
                    </button>
                </div>
            </div>
        </Dialog>
    );
};

export default ArchiveModal;